<app-user-header></app-user-header>

<div class="container-fluid container-m-t">
    <div class="row">
        <div class="col-sm-3 left-panel-mobile-view">
            <div class="row h-105">
                <!-- left sidebar -->
                <div class="col-md-10 fixed pl-0 py-2 left left-sidebar">
                    <ul class="nav flex-md-column flex-nowrap justify-content-center m-l-ipad">
                        <li class="img-circle-styles" style="text-align: center; margin-top: 34px;"><img
                                style="    border: 1px solid #FFF;border-radius: 49%;width: 40%;height: 40%;"
                                src="assets/images/user-image.png" class="img-circle" alt="Cinque Terre">
                            <h5 class="center user-text" style="text-align:  center;">
                                {{ramkiNew.firstName + "  "+ ramkiNew.lastName}} </h5>
                        </li>

                        <li>
                            <a class="nav-link">
                                <!-- <form [formGroup]="form" class="form-styles"> -->
                                <div class="form-group">
                                    <label for="year">Tax Year</label>
                                    <select #mySelected class="form-control"
                                        (change)='onOptionsSelected(mySelected.value)'>
                                        <option disabled>Select Year</option>
                                        <!-- <option>{{data[0]}}</option> -->
                                        <option ([ngModel])="selectedYear" *ngFor="let yr of data">{{yr}}</option>
                                    </select>
                                    <!-- <div *ngIf="f.year.touched && f.year.invalid" class="alert alert-danger">
                                                                    <div *ngIf="f.year.errors.required">Please Select Tax Year</div>
                                                                </div> -->
                                </div>
                                <!-- </form> -->
                            </a>
                        </li>


                        <li class="nav-item" data-toggle="tooltip" data-placement="right" title="Dashboard">
                            <a class="nav-link font-size-ipad" routerLink="/dashboard">
                                <img src="assets/images/dashboard.svg" style="width: auto; height: auto;">&nbsp;
                                <span class="nav-link-text sidebar-text">Dashboard</span>
                            </a>
                        </li><br>

                        <li class="nav-item" data-toggle="tooltip" data-placement="right" title="Basic Information">
                            <a class="nav-link font-size-ipad" routerLink="/basic">
                                <img src="assets/images/information.svg" style="width: auto; height: auto;">&nbsp;
                                <span class="nav-link-text sidebar-text">Basic Information</span>
                            </a>
                        </li><br>
                        <li class="nav-item" data-toggle="tooltip" data-placement="right" title="My Documents"
                            style="background: black;">
                            <a class="nav-link font-size-ipad" routerLink="/documents">
                                <img src="assets/images/doc.svg" style="width: auto; height: auto;">&nbsp;
                                <span class="nav-link-text sidebar-text" style="color: white;">My Documents</span>
                            </a>
                        </li><br>
                        <li class="nav-item" data-toggle="tooltip" data-placement="right" title="Download Tax Return">
                            <a class="nav-link font-size-ipad" routerLink="/download">
                                <img src="assets/images/tax.svg" style="width: auto; height: auto;">&nbsp;
                                <span class="nav-link-text sidebar-text">Download Tax Return</span>
                            </a>
                        </li><br>
                        <li class="nav-item" data-toggle="tooltip" data-placement="right" title="Make Payment">
                            <a class="nav-link font-size-ipad" routerLink="/payment">
                                <img src="assets/images/payment.svg" style="width: auto; height: auto;">&nbsp;
                                <span class="nav-link-text sidebar-text">Make A Payment</span>
                            </a>
                        </li><br>
                        <li class="nav-item" data-toggle="tooltip" data-placement="right" title="Content Of Disclosure">
                            <a class="nav-link font-size-ipad" routerLink="/disclosure">
                                <img src="assets/images/disclosure.svg" style="width: auto; height: auto;">&nbsp;
                                <span class="nav-link-text sidebar-text">Consent Of Disclosure</span>
                            </a>
                        </li>
                    </ul>
                </div>

            </div>
        </div>
        <!-- <div class="col-sm-1"></div> -->
        <div class="col-sm-9 col-m-t">
            <div class="dash-row">My Documents</div>
            <br>

            <div class="" style="padding-bottom: 15px;">
                <a routerLink="/upload" >
                    <button type="submit" class="btn btn-theme"
                        style="background: #ed6624;color:#FFF;margin-left: 3px;">Upload
                        Documents</button>
                </a>
                <a download="EvolvTax-Tax_Organizer.doc" target="_blank" href="assets/EvolvTax-Tax_Organizer.doc">
                    <button type="submit" class="btn btn-theme"
                        style="background: #ed6624;color:#FFF;margin-left: 5px;">
                        <img src="assets/images/download.png">&nbsp;Tax Organizer</button>
                </a>
            </div>
            <br>

            <!-- <div class="table-format">
                <table id="userFiles" class="table table-striped table-bordered" style="width:100%">
                    <thead>
                        <tr>
                            <th>S.No</th>
                            <th>File Ref No</th>
                            <th>File Type</th>
                            <th>File Category</th>
                            <th>Uploaded Date</th>
                            <th>Download</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let tab of uploadListData">
                            <td>{{tab.id}} </td>
                            <td>{{tab.fileNo}} </td>
                            <td>{{tab.fileType}} </td>
                            <td>{{tab.fileCategory}} </td>
                            <td>{{tab.createdDate}} </td>
                            <td><a style="text-decoration: none;"  (click)="downloadFile(tab.fileName)" >Download</a></td>
                        </tr>

                    </tbody>
                </table>
            </div> -->

            <div style="text-align:center; overflow: auto;">

                <table class="table table-striped table-bordered dataTable" style="border: 1px solid #ecf0f1;">
                    <thead>
                        <tr style="background: #19506e;color: #fff;">
                            <th>S.No</th>
                            <th>File Ref No</th>
                            <th>file Name</th>
                            <th>File Type</th>
                            <th>File Category</th>
                            <th>Uploaded Date</th>
                            <th>Download</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            *ngFor="let tab of uploadListData | paginate: { itemsPerPage: 5, currentPage: p }; let i = index">
                            <td>{{(p-1) * 5 + i + 1}} </td>
                            <td >{{tab.fileNo}} </td>
                            <!-- *ngIf="newFileNo" -->
                            <td>{{tab.fileName}} </td>
                            <td>{{tab.fileType}} </td>
                            <td>{{tab.fileCategory}} </td>
                            <td>{{tab.createdDate}} </td>
                            <td><a href="{{tab.fileName}}" style="text-decoration: none; cursor: pointer; color: blue" class="download-styles"
                                (click)="downloadFile(tab.fileName)" >Download</a></td>
                            <!-- <td><a style="text-decoration: none; cursor: pointer; color: blue" class="download-styles"
                                    (click)="downloadFile(tab.fileName)">Download</a></td> -->
                        </tr>
                    </tbody>
                    <thead>
                            <tr style="background: #19506e;color: #fff;">
                                <th>S.No</th>
                                <th>File Ref No</th>
                                <th>file Name</th>
                                <th>File Type</th>
                                <th>File Category</th>
                                <th>Uploaded Date</th>
                                <th>Download</th>
                            </tr>
                        </thead>
                </table>

                <pagination-controls
                    style="background-color: #e9ecef;color: white;border-radius: 8px;padding-top: 12px; width: 60%;"
                    (pageChange)="p = $event" class="float-right pagination-view-desktop"></pagination-controls>

            </div>
            <pagination-controls
                style="background-color: #e9ecef;color: white;border-radius: 8px;padding-top: 12px; width: 60%;"
                (pageChange)="p = $event" class="float-right pagination-view-mobile"></pagination-controls>
            <div>
                <h3>Step 1 :</h3>
                <ul>
                    <li>Filled Tax Organizer<br>
                    </li>
                    <li> Form W2 Statement – Received from all employers that you have worked.</li>
                    <li> 1099 INT/DIV – Interest/Dividend Income - Please provide the document</li>
                    <li> 1099-G : State Refunds received in year <?php echo $userYear;?> for filing
                        <?php echo $userYear-1;?> tax returns </li>
                    <li> 1099-B: Sales of Stock/Securities, Mutual Funds, etc.</li>
                    <li> 1099-R : Income from Pension, IRAs and Annuities</li>
                    <li> K-1 : Partnerships, Trusts, Estates and S-Corporations</li>
                    <li> 1098 T: Scholarships, Fellowships and Grants Form 1042 S, Form 1098 T/E</li>
                    <li> Rental Income (if any in India or USA)</li>
                    <li> INDIAN Interest income if any</li>
                </ul>
            </div>
            <div class="footer" style="text-align: center;background-color: #e9ecef;
                line-height: 55px; color: black;">
                Copyright ©2020 Evolvtax Services Pvt Ltd. All rights reserved
            </div>
        </div>
    </div>
    <ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
        <p style="color: white">Loading </p>
    </ngx-spinner>
</div>